<style>
#change-password--form input,
#change-password--form label {
  font-size: 12px;
}
.disabled {
  background-color: lightgrey !important;
  cursor: not-allowed !important;
  pointer-events: none !important;
}
#result-text {
  text-align: center;
  color: rgb(42, 87, 154);
}
#result-text--card {
  width: 520px !important;
  height: 40px !important;
  line-height: 10px;
}
.errorColor {
  color: red !important;
}
.noDisplay {
  display: none;
}
</style>

<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card id="result-text--card" :class="{noDisplay: success === undefined}">
          <v-card-text>
            <p id="result-text" :class="{errorColor: !success}">{{ resultText }}</p>
          </v-card-text>
        </v-card>
        <br>
        <v-card style="width:520px !important; height: 260px !important;">
          <v-card-text>
            <v-icon
              title="W celu zmiany hasła należy wpisać je dwukrotnie, a następnie zatwierdzić przyciskiem poniżej. W przypadku udanej próby nastąpi przekierowanie na stronę logowania"
              style="float: right;"
            >help</v-icon>
            <br>
            <v-form id="change-password--form">
              <v-text-field
                name="firstPassword"
                label="Nowe hasło"
                type="password"
                v-model="firstPassword"
                id="first-password--input"
                :rules="[rules.required]"
                oncopy="return false"
                onpaste="return false"
              ></v-text-field>
              <v-text-field
                name="secondPassword"
                label="Powtórz nowe hasło"
                type="password"
                v-model="secondPassword"
                id="second-password--input"
                :error-messages="emailMatchError()"
                :rules="[rules.required]"
                oncopy="return false"
                onpaste="return false"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-layout>
              <v-flex d-flex justify-center>
                <v-flex xs3>
                  <v-btn
                    small
                    dark
                    depressed
                    color="#2a579a"
                    @click="changePassword"
                    :class="{disabled: !match}"
                  >Zmień hasło</v-btn>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <modals-container/>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    firstPassword: "",
    secondPassword: "",
    match: false,
    rules: {
      required: value => !!value || "Pole wymagane"
    },
    resultText: "",
    success: undefined
  }),
  watch: {
    firstPassword(val) {
      this.resultText = "";
      this.firstPassword = val;
      if (val.length > 0 && val == this.secondPassword) {
        this.match = true;
      } else {
        this.match = false;
      }
    },
    secondPassword(val) {
      this.resultText = "";
      this.secondPassword = val;
      if (val.length > 0 && val == this.firstPassword) {
        this.match = true;
        this.emailMatchError();
      } else {
        this.match = false;
      }
    }
  },
  methods: {
    emailMatchError() {
      return this.firstPassword == this.secondPassword
        ? ""
        : "Podane hasła muszą być identyczne";
    },
    changePassword() {
      const self = this;
      let pathArr = window.location.pathname.split("/");
      let uid = pathArr[pathArr.length - 1];
      let payload = {
        hashid: uid,
        body: {
          password: this.secondPassword
        }
      };

      this.$store.dispatch("resetPassword", payload).then(res => {
        if (res) {
          this.success = true;
          self.resultText =
            "Hasło zmienione! Zostaniesz teraz przeniesiony na stronę logowania.";
          setTimeout(() => {
            self.$router.push({ name: "login" });
          }, 3000);
        } else {
          this.success = false;
          self.resultText = "Wystąpił błąd podczas zmiany hasła.";
        }
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/login/ResetPassword.vue